export default __webpack_public_path__ + "static/media/gallery_03.345bb89b.jpg";